import { createUseStyles } from 'react-jss';
import { FontWeight } from '@quicktools/shared-components';

export default createUseStyles(
  {
    root: {},
    heading: {
      color: '#000000',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: FontWeight.Bold,
      marginBottom: 12,
    },
  },
  { name: 'category-filter' },
);
